import React from "react";
import heroImg from "../assets/img/heroImage.gif";
import Container from "./Container";
const Hero = () => {
  return (
    <Container className={"mt-auto 	"}>
      <div className="py-5 lg:py-0 md:my-0 my-5">
        <div className="h-full lg:gap-8 grid items-center grid-cols-12">
          <div className="col-span-7 text-left">
            <h1 className="w-full xxl:text-[135px] xl:text-[80px] lg:w-10/12 uppercase text-2xl smtext-3xl lg:text-4xl xl:text-6xl font-bold font-poppins tracking-wide">
              OWNERSHIP
              <br className="block smhidden md:block" />
              <span className="ml-0 smml-1 md:ml-0">made simple</span>
            </h1>
            <p className="text-sm xxl:text-[55px] xxl:leading-[60px] smtext-md smtext-2xl mt-2 md:mt-4 xl:mt-8 font-poppins">
              The first decentralized sports exchange to buy
              <br className="hidden lg:block" />
              <span className="ml-1 lg:ml-0">
                ownership in your favorite sports teams, just like stocks.
              </span>
            </p>
          </div>
          <div className="col-span-5 ">
            <div className=" mx-auto flex items-center justify-center">
              <img
                src={heroImg}
                alt=""
                // className="ml-10 smml-14 md:ml-20 lg:ml-16 sm-mr-24 lg:-mr-36 w-52 smw-60 md:w-80 lg:w-80 max-w-fit"
                className="-mr-2 xxl:w-[500px] xxl:h-[1000px]  xl:w-[300px] md:-mr-5 w-28 smw-36 md:w-52 lg:w-60 max-w-fit"
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Hero;
